import React, { Fragment } from 'react'
import { H2 } from '@blueprintjs/core'
import PieComponent from './PieComponent'

const CamamAge = ({
    pieR5R12,
    pieR1R12,
    pieR5R10,
    pieR1R10,
    pieR5R8,
    pieR1R8,
    pieR1R6,
    pieR5R6,
    pieR1R4,
    pieR5R4,
    context,
    contextDetail,
    contextLeft,
    contextRight
}) => {

    const COLORS = ['#1F77B4', '#FF7F0E', '#2CA02C', '#D62728', '#9467BD', '#8C564B', '#E377C2'];

    return (
        <div className='margin-top-large margin-bottom-large'>
            <H2 className='text-center margin-top-large margin-bottom-large new-results'>{context}
                {/* Tranche d'âge des votants selon l'indice d'ouverture */}
                {contextDetail ? <Fragment><br />{contextDetail}</Fragment> : ""}
            </H2>
            <br />
            <div className='margin-top-large margin-bottom-large pieContainer'>
                <div className="indiceTitle leftPie">
                    <H2 className='text-center new-results'>{contextLeft ? contextLeft : 'R+5'}</H2>
                </div>
                <div className="indiceTitle ">
                    <H2 className='text-center new-results'>{contextRight ? contextRight : 'R+1'}</H2>
                </div>
                <PieComponent
                    data={pieR5R12}
                    COLORS={COLORS}
                    ratio="1/12"
                    left={true}
                />
                <PieComponent
                    data={pieR1R12}
                    COLORS={COLORS}
                    ratio="1/12"
                />
                <PieComponent
                    data={pieR5R10}
                    COLORS={COLORS}
                    ratio="1/10"
                    left={true}
                />
                <PieComponent
                    data={pieR1R10}
                    COLORS={COLORS}
                    ratio="1/10"
                />
                <PieComponent
                    data={pieR5R8}
                    COLORS={COLORS}
                    ratio="1/8"
                    left={true}
                />
                <PieComponent
                    data={pieR1R8}
                    COLORS={COLORS}
                    ratio="1/8"
                />

                <PieComponent
                    data={pieR5R6}
                    COLORS={COLORS}
                    ratio="1/6"
                    left={true}
                />
                <PieComponent
                    data={pieR1R6}
                    COLORS={COLORS}
                    ratio="1/6"
                />
                <PieComponent
                    data={pieR5R4}
                    COLORS={COLORS}
                    ratio="1/4"
                    left={true}
                />
                <PieComponent
                    data={pieR1R4}
                    COLORS={COLORS}
                    ratio="1/4"
                />
            </div>
        </div>
    )
}

export default CamamAge
